import { CodeIcon, GlobeIcon } from '@phosphor-icons/react'
import { useEffect, useState } from 'react'
import { NavBar } from './NavBar.tsx'
import { Link, navigate } from './Router.tsx'
import { useNavBarHeightStore } from './store.ts'
import { getAllTutorials, type TutorialInfo } from './tutorials/index.ts'

export function TutorialList() {
  const { height: navBarHeight } = useNavBarHeightStore()
  const [tutorials, setTutorials] = useState<TutorialInfo[]>([])

  useEffect(() => {
    setTutorials(getAllTutorials())
  }, [])

  const rightSideButtons = (
    <>
      <Link
        href="/"
        className="px-4 h-8 text-sm border-none rounded-md cursor-pointer font-semibold bg-gradient-to-br from-lime-400 to-green-600 text-white hover:opacity-90 no-underline flex items-center gap-2"
      >
        <GlobeIcon weight="regular" size={16} />
        <span className="hidden md:inline">Browse</span>
      </Link>
      <Link
        href="/editor"
        className="px-4 h-8 text-sm border-none rounded-md cursor-pointer font-semibold bg-gradient-to-br from-orange-500 to-red-600 text-white hover:opacity-90 no-underline flex items-center gap-2"
      >
        <CodeIcon weight="regular" size={16} />
        Switch to Editor
      </Link>
    </>
  )

  return (
    <div className="w-[100dvw] h-[100dvh] overflow-hidden text-[#f0f0f0] flex flex-col relative">
      <NavBar rightSideButtons={rightSideButtons} />
      <div className="relative flex" style={{ height: `calc(100dvh - ${navBarHeight}px)` }}>
        <div className="relative h-full overflow-y-auto overflow-x-hidden p-10 flex-1">
          <div className="max-w-4xl mx-auto space-y-8">
            <div className="prose prose-invert max-w-none">
              <h1 className="text-4xl font-extrabold font-[Turret_Road] text-lime-400 mb-6">
                Tutorials
              </h1>
              <p className="text-lg text-[#e0e0e0] leading-relaxed mb-8">
                Learn how to create sounds and music with loopmaster. Choose a tutorial to get started.
              </p>
            </div>

            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-2">
              {tutorials.map(tutorial => (
                <button
                  key={tutorial.id}
                  onClick={() => navigate(`/tutorials/${tutorial.id}`)}
                  className="flex flex-col text-left p-6 rounded-lg border border-[#333] bg-[#1a1a1a] hover:bg-[#2a2a2a] hover:border-lime-400 transition-colors group"
                >
                  <h2 className="text-xl font-bold text-lime-400 mb-2 font-[Turret_Road] group-hover:text-lime-300">
                    {tutorial.title}
                  </h2>
                  {tutorial.description && (
                    <p className="text-[#e0e0e0] text-sm leading-relaxed">
                      {tutorial.description}
                    </p>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
